import React, { useEffect, useState, useRef } from "react";
import "./scanCenterCases.scss";
import { CaseDetail } from "../../../models/CaseDetail/caseDetail.model";
import AdminCaseService from "../../../services/Case/AdminCase/adminCase.service";
import ScanCenterCaseService from "../../../services/Case/ScanCenterCase/scanCenterCase.service";
import moment from "moment";
import ContextMenu from "../../../shared/components/ContextMenu";
import { Tag } from "../../../models/Tag/tag.model";
import TagLegend from "../../../shared/components/TagLegend";
import {
  Badge,
  Button,
  Col,
  Input,
  Menu,
  Modal,
  Popover,
  Row,
  Switch,
  Table,
  TablePaginationConfig,
  Tooltip,
} from "antd";
import AppLoader from "../../../shared/components/AppLoader";
import AppCard from "../../../shared/components/AppCard";
import CaseOverview from "../../../shared/components/CaseOverview";
import {
  EditOutlined,
  PlusOutlined,
  DownloadOutlined,
  CopyOutlined,
  WhatsAppOutlined,
  ShareAltOutlined,
  HistoryOutlined,
  UserAddOutlined,
  CommentOutlined,
  QrcodeOutlined,
} from "@ant-design/icons";
import CaseForm from "./CaseForm";
import { CaseStatusEnum } from "../../../enums/caseStatus.enum";
import ReportService from "../../../services/Report/report.service";
import { DownloadFileTypeEnum } from "../../../enums/downloadFileType.enum";
import { CaseBodyPart } from "../../../models/CaseBodyPart/caseBodyPart.model";
import CaseContainer from "../../../store/container/CaseContainer";
import { CaseReducerProps } from "../../../store/reducers/caseReducer";
import CaseFilterForm from "../../../shared/components/CaseFilterForm";
import { CaseFilterParams } from "../../../models/CaseFilterParams/caseFilterParams.model";
import SharedCaseService from "../../../services/Shared/shared.service";
import {
  copyCaseDetailsToClipboard,
  copyImageToClipboard,
  stopPropogateEvent,
} from "../../../shared/utils/eventUtils";
import { buildCaseDetailViewerUrl } from "../../../shared/utils/caseViewerOpenUrl";
import Notification from "../../../shared/components/Notification";
import { NotificationTypes } from "../../../enums/notificationTypes";
import { PaginationMeta } from "../../../models/PaginationMeta/paginationMeta.model";
import { useHistory, useLocation } from "react-router-dom";
import {
  getCustomCellStyles,
  getInitialFiltersFromURL,
  formatStatus,
  hexToRgba,
} from "../../../shared/utils/dataFormatConverter";
import ProfileService from "../../../services/Profile/profile.service";
import { UserRoleEnum } from "../../../enums/userRole.enum";
import { ScanCenter } from "../../../models/ScanCenter/scanCenter.model";
import { AdminFeatureEnum } from "../../../enums/AdminFeature.enum";
import { TagEnum } from "../../../enums/tag.enum";
import { ColumnsType } from "antd/lib/table";
import ReportHistory from "../../../shared/components/ReportHistory";
import { Report } from "../../../models/Report/report.model";
import CaseSeriesExpandRow from "../../../shared/components/CaseSeriesExpandRow";
import CaseAssignmentForm from "../AdminCases/CaseAssignmentForm";
import CaseSharing from "../../../shared/components/CaseSharing";
import ListingColumnPreferenceService, {
  ListingColumnPreferencesResponse,
} from "../../../services/ListingColumnPreference/listingColumnPreference.service";
import {
  LISTING_CONTEXT,
  ListingColumnKey,
  SCAN_CENTER_ACTIONS_COLUMN_MIN_WIDTH,
  SCAN_CENTER_DEFAULT_ACTIONS_COLUMN_WIDTH,
  minWidthForListingColumnKey,
} from "../../../constants/listingColumnKeys";
import { applyListingColumnPreferences } from "../../../utils/listingColumns/applyListingColumnPreferences";
import { mergeListingWidthsFromTable } from "../../../utils/listingColumns/mergeListingWidthsFromTable";
import { ScanCenterFeatureEnum } from "../../../enums/ScanCenterFeature.enum";
import {
  buildCaseChatUnreadCountsFromCases,
  getDisplayedCaseChatUnread,
} from "../../../shared/utils/caseChatUnread";
import { useHighlightCaseRowFromQuery } from "../../../shared/hooks/useHighlightCaseRowFromQuery";
import CaseChatDrawer from "../../../shared/components/CaseChatDrawer";

const getReportedReports = (caseDetail: CaseDetail | undefined) =>
  caseDetail?.reports?.filter((r) => r.status === true) ?? [];

interface ScanCenterCasesProps extends CaseReducerProps {}

function ScanCenterCases({
  pendingCaseIds,
  completedCaseIds,
  uploadStartedCaseIds,
  createdCaseId,
  updatedCaseId,
  deletedCaseId,
  setNewCaseCreated,
  setCaseDetailUpdated,
  setCaseDeleted,
  caseChatUnreadCounts,
  mergeCaseChatUnread,
  setCaseChatDrawerCaseId,
}: ScanCenterCasesProps) {
  const location = useLocation();

  const [caseDetails, setCaseDetails] = useState<CaseDetail[]>([]);

  const [me, setMe] = useState<ScanCenter>();

  const [paginationMeta, setPaginationMeta] = useState<PaginationMeta>(
    Object.assign(new PaginationMeta(), {
      currentPage: 1,
      totalCount: 0,
      totalPages: 0,
    })
  );

  const [loading, setLoading] = useState(false);

  const { rowClassName: caseListRowClassName } = useHighlightCaseRowFromQuery(
    caseDetails,
    loading
  );

  const [isSyncing, setSyncing] = useState(false);

  const [downloadLoading, setDownloadLoading] = useState(false);

  const [activeCase, setActiveCase] = useState<CaseDetail>();

  const [showCaseForm, setShowCaseForm] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [showReportHistory, setShowReportHistory] = useState(false);

  const [activePopoverId, setActivePopoverId] = useState<number | null>(null);

  const [phoneNumber, setPhoneNumber] = useState("");

  const [menuVisible, setMenuVisible] = useState(false);

  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [caseChat, setCaseChat] = useState<{ id: number; title: string } | null>(
    null
  );

  const [selectedRow, setSelectedRow] = useState<any>(null);

  const menuRef = useRef<HTMLDivElement>(null);

  const [formValues, setFormValues] = useState<CaseFilterParams>(
    Object.assign(new CaseFilterParams(), {
      ...new CaseFilterParams(),
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      scanCenterBranchId: undefined,
      page: 1,
    })
  );

  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);

  const resizingColumnRef = useRef(null);

  const startXRef = useRef(0);

  const startWidthRef = useRef(0);

  const history = useHistory();

  const [showCaseOverview, setShowCaseOverview] = useState(false);

  const [assignPopoverOpenCaseId, setAssignPopoverOpenCaseId] = useState<
    number | null
  >(null);

  const adminFeatures = me?.adminFeatures?.map(
    (adminFeature) => adminFeature.feature
  );

  const updateUrlParams = (values: CaseFilterParams) => {
    const searchParams = new URLSearchParams();
    // Add non-empty filter values to URL
    Object.entries(values).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        searchParams.set(key, String(value));
      }
    });
    // Update URL without page reload
    history.replace(`${location.pathname}?${searchParams.toString()}`);
  };

  const handleToggleCaseForm = () =>
    setShowCaseForm((showCaseForm) => !showCaseForm);

  const handleCloseCaseOverview = () => setShowCaseOverview(false);

  const handleToggleReportHistory = () => setShowReportHistory((showReportHistory) => !showReportHistory);

  const handleFetchCases = (formValues: CaseFilterParams, isSyncing: boolean = false) => {
    if(isSyncing) {
      setSyncing(true);
    } else {
      setLoading(true);
    }
    ScanCenterCaseService.fetchScanCenterCases(
      formValues,
      (caseDetails: CaseDetail[], paginationMeta: PaginationMeta) => {
        setCaseDetails(caseDetails);
        setPaginationMeta(paginationMeta);
        mergeCaseChatUnread(buildCaseChatUnreadCountsFromCases(caseDetails));
      },
      () => {},
      () => {
        if(isSyncing) {
          setSyncing(false);
        } else {
          setLoading(false);
        }
      }
    );
  };

  const handleSeriesOpen = (caseId: number, seriesIds: string[]) => {
    // Join raw folder paths with a comma — URLSearchParams.set (inside
    // buildCaseDetailViewerUrl) percent-encodes the value exactly once.
    // Encoding here would cause double-encoding and break the viewer fetch.
    const seriesCsv = seriesIds.length > 0 ? seriesIds.join(",") : undefined;
    window.open(
      buildCaseDetailViewerUrl(caseId, seriesCsv ? { seriesIdCsv: seriesCsv } : undefined),
      "_blank"
    );
  };

  const handleRowChange = (caseDetail: CaseDetail, _: number | undefined) => {
    return {
      onClick: (event: any) => {
        if (event.target.closest(".ant-table-row-expand-icon")) return;
        setActiveCase(caseDetail);
        setShowCaseOverview(true);
      },
      onContextMenu: (event: React.MouseEvent) =>
        handleRowContextMenu(caseDetail, event),
    };
  };

  const handleUpdateTags = (caseId: number, tags: Tag[]) => {
    const caseIndex = caseDetails.findIndex(
      (caseItem) => caseItem.id === caseId
    );
    if (caseIndex >= 0) {
      caseDetails[caseIndex].tags = tags;
    }
    setCaseDetails([...caseDetails]);
  };

  const handlePageChange = (pagination: TablePaginationConfig) => {
    const values = Object.assign(new CaseFilterParams(), {
      ...formValues,
      page: pagination.current,
      perPage: pagination.pageSize,
    });
    updateUrlParams(values);
  };

  const handleResetFilters = () => {
    history.replace(location.pathname);
  };

  const handleUploadCaseSuccess = (caseDetail: CaseDetail) => {
    const caseIndex = caseDetails.findIndex(
      (caseItem) => caseItem.id === caseDetail.id
    );
    if (caseIndex >= 0) {
      caseDetails[caseIndex] = caseDetail;
    } else {
      caseDetails.unshift(caseDetail);
    }
    setCaseDetails([...caseDetails]);
  };

  const handleAddCase = () => {
    setActiveCase(new CaseDetail());
    handleToggleCaseForm();
  };

  const handleEditCase = (caseDetail: CaseDetail) => () => {
    setActiveCase(caseDetail);
    handleToggleCaseForm();
  };

  const handleAssignmentSuccess = (updated: CaseDetail) => {
    setCaseDetails((prev) =>
      prev.map((c) => {
        if (c.id !== updated.id) return c;
        const merged = Object.assign(new CaseDetail(), c, updated);
        // Assign API returns `status` (assignment) but often omits `case_status`; keep listing fields.
        if (merged.caseStatus == null || merged.caseStatus === "") {
          merged.caseStatus =
            updated.caseStatus ?? (updated.status as string | undefined) ?? c.caseStatus;
        }
        if (merged.uploadStatus == null || merged.uploadStatus === "") {
          merged.uploadStatus = c.uploadStatus;
        }
        return merged;
      })
    );
    setAssignPopoverOpenCaseId(null);
    if (activeCase?.id === updated.id) {
      setActiveCase((prev) => {
        if (!prev || prev.id !== updated.id) return prev;
        const merged = Object.assign(new CaseDetail(), prev, updated);
        if (merged.caseStatus == null || merged.caseStatus === "") {
          merged.caseStatus =
            updated.caseStatus ?? (updated.status as string | undefined) ?? prev.caseStatus;
        }
        if (merged.uploadStatus == null || merged.uploadStatus === "") {
          merged.uploadStatus = prev.uploadStatus;
        }
        return merged;
      });
    }
  };

  const handleSubmit = (values: CaseFilterParams) => {
    const formValues = Object.assign(new CaseFilterParams(), values);
    setFormValues(formValues);
    handleFetchCases(formValues);
  };

  // const handleOnChange = (updatedValues: CaseFilterParams) => {
  //   // Update the form values with new inputs
  //   const newFormValues = Object.assign(new CaseFilterParams(), updatedValues);
  //   setFormValues(newFormValues);

  //   // Clear any existing debounce timer
  //   if (debounceTimerRef.current) {
  //     clearTimeout(debounceTimerRef.current);
  //   }
  //   // Set a new debounce timer
  //   debounceTimerRef.current = setTimeout(() => {
  //     handleFetchCases(newFormValues, paginationMeta); // Call the fetch function with the updated form values
  //   }, 500); // 500ms debounce delay
  // };

  // Cleanup on component unmount to clear the debounce timer
  useEffect(() => {
    ProfileService.getProfile(
      UserRoleEnum.SCAN_CENTER,
      (scanCenter: ScanCenter) => {
        setMe(scanCenter);
      },
      () => {},
      () => {}
    );
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  const handleDownloadCase = (
    caseDetail: CaseDetail,
    fileType: DownloadFileTypeEnum,
    withLetterHead: boolean,
    reportId?: number
  ) => {
    if (caseDetail?.id) {
      setDownloadLoading(true);
      setActiveCase(caseDetail);
      ReportService.downloadScanCenterReport(
        fileType,
        caseDetail,
        withLetterHead,
        reportId ?? 0,
        (reportUrl: string) => {
          window.open(reportUrl, "_blank");
        },
        () => {},
        () => {
          setDownloadLoading(false);
          setActiveCase(undefined);
        }
      );
    }
  };

  const handleViewReport = (
      caseDetail: CaseDetail,
      reportId?: number,
  ) => {
    setActiveCase(caseDetail);
    setDownloadLoading(true);
    if (caseDetail?.id) {
      const apiMethod = ReportService.previewScanCenterReport;
      apiMethod(
          caseDetail?.id,
          reportId ?? 0,
          (data: Blob) => {
            const fileURL = window.URL.createObjectURL(
                new Blob([data], { type: "application/pdf" })
            );
            const pdfWindow = window.open(fileURL, "_blank");
            if (pdfWindow) {
              pdfWindow.onload = () => {
                window.URL.revokeObjectURL(fileURL);
              };
            }
          },
          () => {},
          () => {
            setActiveCase(undefined);
            setDownloadLoading(false);
          }
      );
    }
  };

  const handleDownloadDirectReport = (
    caseDetail: CaseDetail | undefined,
    reportId?: number | undefined,
  ) => {
    if (caseDetail?.id) {
      ReportService.downloadScanCenterDirectReport(
          caseDetail?.id,
          reportId ?? 0,
          (reportUrl: string) => {
            window.open(reportUrl, "_blank");
          },
          () => {},
          () => {
          }
      );
    }
  };

  const handleCaseShareLink = (caseDetail: CaseDetail) => {
    setActiveCase(caseDetail);
    if (caseDetail?.id) {
      SharedCaseService.getCaseShareLink(
        Number(caseDetail?.id),
        (targetUrl: any) => {
          copyCaseDetailsToClipboard(caseDetail, targetUrl);
        },
        () => {},
        () => {}
      );
    }
  };

  // Mirror of the admin "Copy QR" handler: fetches a share link and copies
  // the QR image returned by the backend (data:image/png;base64) directly
  // onto the system clipboard so the scan center can paste it into chat /
  // docs as an image. Kept on scan center only when the parent admin has
  // DIGITAL_SHARING enabled (feature flag is still read from
  // `me.adminFeatures`, which is the scan center's admin's feature set).
  const handleCaseShareQr = (caseDetail: CaseDetail) => {
    setActiveCase(caseDetail);
    if (!caseDetail?.id) return;
    SharedCaseService.getCaseShareLink(
      Number(caseDetail.id),
      async (_link: string, _token: string, qrCode: string) => {
        if (!qrCode) {
          Notification({
            message: "QR code unavailable for this case",
            type: NotificationTypes.ERROR,
          });
          return;
        }
        const ok = await copyImageToClipboard(qrCode);
        Notification({
          message: ok
            ? "QR copied — paste anywhere you need"
            : "Unable to copy QR to clipboard",
          type: ok ? NotificationTypes.SUCCESS : NotificationTypes.ERROR,
        });
      },
      () => {},
      () => {}
    );
  };

  const handleToggleUrgency = (
    isUrgent: boolean,
    caseDetail: CaseDetail,
    switchElement: EventTarget | null
  ) => {
    setActiveCase(caseDetail);
    caseDetail.isUrgent = isUrgent;
    ScanCenterCaseService.updateScanCenterCase(
      caseDetail,
      (updatedCaseDetail: CaseDetail) => {
        if (switchElement instanceof HTMLElement) {
          switchElement.style.backgroundColor = isUrgent ? "red" : "gray";
        }
        setActiveCase(updatedCaseDetail);
      },
      () => {
        if (switchElement instanceof HTMLElement) {
          switchElement.click();
          switchElement.style.backgroundColor = isUrgent ? "gray" : "red";
        }
      },
      () => {}
    );
  };

  useEffect(() => {
    if (createdCaseId) {
      handleFetchCases(formValues, true);
      setNewCaseCreated(null);
    }
  }, [createdCaseId, setNewCaseCreated]);

  useEffect(() => {
    if (deletedCaseId) {
      handleFetchCases(formValues, true);
      setCaseDeleted(null);
    }
  }, [deletedCaseId, setCaseDeleted]);

  useEffect(() => {
    if (updatedCaseId) {
      // Commented for future use
      // const caseIndex = caseDetails.findIndex(
      //   (caseDetail) => caseDetail.id === updatedCaseDetail.id
      // );
      // if (caseIndex >= 0) {
      //   caseDetails[caseIndex] = updatedCaseDetail;
      //   setCaseDetails([...caseDetails]);
      // }
      handleFetchCases(formValues, true);
      setCaseDetailUpdated(null);
    }
  }, [updatedCaseId, setCaseDetailUpdated]);

  const [columns, setColumns] = useState<any>([]);

  const [listingPrefsApi, setListingPrefsApi] = useState<
    ListingColumnPreferencesResponse | null | undefined
  >(undefined);

  const columnsRef = useRef<any[]>([]);
  const listingPrefsRef = useRef(listingPrefsApi);
  useEffect(() => {
    columnsRef.current = columns;
  }, [columns]);
  useEffect(() => {
    listingPrefsRef.current = listingPrefsApi;
  }, [listingPrefsApi]);

  const handleMouseDown = (e: any, index: any) => {
    resizingColumnRef.current = index;
    startXRef.current = e.clientX;
    startWidthRef.current = columns[index].width;

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e: any) => {
    if (resizingColumnRef.current !== null) {
      const idx = resizingColumnRef.current;
      const newWidth = startWidthRef.current + (e.clientX - startXRef.current);
      const newColumns = [...columns];
      const key = newColumns[idx]?.listingColumnKey;
      const minW = minWidthForListingColumnKey(
        key,
        SCAN_CENTER_ACTIONS_COLUMN_MIN_WIDTH
      );
      newColumns[idx].width = Math.max(newWidth, minW);
      columnsRef.current = newColumns;
      setColumns(newColumns);
    }
  };

  const handleMouseUp = () => {
    const idx = resizingColumnRef.current;
    resizingColumnRef.current = null;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
    if (idx === null) return;
    const prefs = listingPrefsRef.current;
    const cols = columnsRef.current;
    if (!prefs?.columns?.length) return;
    const endW = cols[idx]?.width;
    if (endW === undefined) return;
    if (Math.round(Number(startWidthRef.current)) === Math.round(Number(endW))) return;
    const rows = mergeListingWidthsFromTable(cols, prefs.columns, {
      actionsMinWidth: SCAN_CENTER_ACTIONS_COLUMN_MIN_WIDTH,
    });
    ListingColumnPreferenceService.save(
      UserRoleEnum.SCAN_CENTER,
      LISTING_CONTEXT.SCAN_CENTER_CASES,
      rows,
      (res) => {
        setListingPrefsApi((prev) =>
          prev && res.columns ? { ...prev, columns: res.columns } : prev
        );
      },
      () => {},
      () => {}
    );
  };

  const handleRowContextMenu = (
    record: CaseDetail,
    event: React.MouseEvent
  ) => {
    event.preventDefault();
    setSelectedRow(record);
    setMenuPosition({ x: event.pageX, y: event.pageY });
    setMenuVisible(true);
  };

  useEffect(() => {
    const initialFilters = getInitialFiltersFromURL(location.search);
    setFormValues(initialFilters);
    handleFetchCases(initialFilters);
  }, [location.search]);

  useEffect(() => {
    if (!me?.id) return;
    ListingColumnPreferenceService.fetch(
      UserRoleEnum.SCAN_CENTER,
      LISTING_CONTEXT.SCAN_CENTER_CASES,
      (data) => setListingPrefsApi(data),
      () => setListingPrefsApi(null),
      () => {}
    );
  }, [me?.id]);

  useEffect(() => {
    if (!me || listingPrefsApi === undefined) return;

    const screenWidth = window.innerWidth;
    const adminFeatures = me?.adminFeatures?.map(
      (adminFeature) => adminFeature.feature
    );

    const hasAssignmentCapability =
      me?.assignmentCapability === true ||
      me?.scanCenterFeatures?.some(
        (f) => f.feature === ScanCenterFeatureEnum.ASSIGNMENT_CAPABILITY
      );

    const defs: Record<string, any> = {};

    defs[ListingColumnKey.TAGS] = {
        listingColumnKey: ListingColumnKey.TAGS,
        title: "Tags",
        dataIndex: "id",
        key: "id",
        width: 75,
        ellipsis: true,
        fixed: screenWidth > 900 ? "left" : undefined,
        render: (_: number, caseDetail: CaseDetail) => (
          <div className="scan-center-cases__tags">
            {caseDetail?.tags?.filter((tag) => tag?.name?.toLowerCase() !== TagEnum.CASE_OPENED).map((tag) => {
              const isInteresting = tag?.name?.toLowerCase() === TagEnum.INTERESTING;
              const tooltipTitle = isInteresting && tag?.keyword
                ? `${tag.formattedName}: ${tag.keyword}`
                : tag.formattedName;
              return (
                <Tooltip title={tooltipTitle} key={tag.id}>
                  <span
                    className="scan-center-cases__tag-item"
                    style={{ backgroundColor: tag.color }}
                  />
                </Tooltip>
              );
            })}
          </div>
        ),
        onCell: (caseDetail: CaseDetail) => {
          const caseOpenedTag = caseDetail?.tags?.find(
            (tag) => tag?.name?.toLowerCase() === TagEnum.CASE_OPENED
          );
          return caseOpenedTag
            ? { className: "scan-center-cases__tag-cell--case-opened", style: { "--case-opened-bg": hexToRgba(caseOpenedTag.color ?? "#000000", 1) } as React.CSSProperties }
            : {};
        },
      };

    defs[ListingColumnKey.PATIENT_ID] = {
        listingColumnKey: ListingColumnKey.PATIENT_ID,
        title: "Patient ID",
        dataIndex: "patientId",
        key: "patientId",
        width: 100,
        fixed: screenWidth > 900 ? "left" : undefined,
        onCell: getCustomCellStyles(100),
      };

    defs[ListingColumnKey.PATIENT_NAME] = {
        listingColumnKey: ListingColumnKey.PATIENT_NAME,
        title: "Patient name",
        dataIndex: "patientName",
        key: "patientName",
        width: 150,
        ellipsis: true,
        fixed: screenWidth > 900 ? "left" : undefined,
        onCell: getCustomCellStyles(150),
      };

    defs[ListingColumnKey.PATIENT_AGE] = {
        listingColumnKey: ListingColumnKey.PATIENT_AGE,
        title: "Age",
        dataIndex: "age",
        key: "age",
        width: 80,
        ellipsis: true,
        onCell: getCustomCellStyles(80),
      };

    defs[ListingColumnKey.PATIENT_GENDER] = {
        listingColumnKey: ListingColumnKey.PATIENT_GENDER,
        title: "Gender",
        dataIndex: "gender",
        key: "gender",
        width: 90,
        ellipsis: true,
        onCell: getCustomCellStyles(90),
      };

    defs[ListingColumnKey.STUDY] = {
        listingColumnKey: ListingColumnKey.STUDY,
        title: "Study",
        dataIndex: "scanTypeName",
        key: "scanTypeName",
        width: 120,
        ellipsis: true,
        onCell: getCustomCellStyles(120),
        render: (_: string, record: CaseDetail) => (
          <span className="admin-cases__study">{record?.getStudyName()}</span>
        ),
      };

    defs[ListingColumnKey.REFERRING_DOCTOR] = {
        listingColumnKey: ListingColumnKey.REFERRING_DOCTOR,
        title: "Referring Doctor",
        dataIndex: "referringDoctor",
        key: "referringDoctor",
        width: 120,
        ellipsis: true,
        onCell: getCustomCellStyles(120),
      };

    if (
      adminFeatures &&
      adminFeatures?.includes(AdminFeatureEnum.SHOW_PATIENT_HISTORY)
    ) {
      defs[ListingColumnKey.PATIENT_HISTORY] = {
              listingColumnKey: ListingColumnKey.PATIENT_HISTORY,
              title: "Patient History",
              dataIndex: "parsedPatientHistory",
              key: "parsedPatientHistory",
              width: 150,
              ellipsis: true,
              onCell: getCustomCellStyles(150),
            };
    }

    if (
      adminFeatures &&
      adminFeatures?.includes(AdminFeatureEnum.ACQUISITION_DATE)
    ) {
      defs[ListingColumnKey.STUDY_DATE] = {
        listingColumnKey: ListingColumnKey.STUDY_DATE,
        title: "Study Date",
        dataIndex: "studyDate",
        key: "studyDate",
        ellipsis: true,
        width: 150,
        onCell: getCustomCellStyles(150),
        sorter: (a: any, b: any) => {
          const dateA = a.acquisitionDate || "";
          const dateB = b.acquisitionDate || "";
          return dateA.localeCompare(dateB);
        },
        render: (_: string, record: any) => {
          const date = record.acquisitionDate;
          return (
            <span>
              {date ? (
                <span>
                  {moment(date).format("DD-MMM-YY")}{" "}
                  {moment(date).format("hh:mm A")}
                </span>
              ) : (
                "-"
              )}
            </span>
          );
        },
      };
    }

    defs[ListingColumnKey.UPLOADED_DATE] = {
        listingColumnKey: ListingColumnKey.UPLOADED_DATE,
        title: "Uploaded Date",
        dataIndex: "uploadedDate",
        key: "uploadedDate",
        sorter: (a: any, b: any) => {
          const dateA = a.createdAt || "";
          const dateB = b.createdAt || "";
          return dateA.localeCompare(dateB);
        },
        ellipsis: true,
        render: (_: string, record: any) => {
          const date = record.createdAt || "";
          return (
            <span>
              {date ? (
                <span>
                  {moment(date).format("DD-MMM-YY")}{" "}
                  {moment(date).format("hh:mm A")}
                </span>
              ) : (
                "NA"
              )}
            </span>
          );
        },
        width: 150,
        onCell: getCustomCellStyles(150),
      };

    if (hasAssignmentCapability) {
      defs[ListingColumnKey.ASSIGNED_DOCTOR] = {
        listingColumnKey: ListingColumnKey.ASSIGNED_DOCTOR,
        title: "Assigned Doctor",
        dataIndex: "assignedToDoctorName",
        key: "assignedToDoctorName",
        width: 130,
        ellipsis: true,
        onCell: getCustomCellStyles(130),
        render: (name: string | undefined) => name ?? "-",
      };
    }

    if (
      adminFeatures &&
      adminFeatures?.includes(AdminFeatureEnum.SCANCENTER_SHOW_REPORTED_DOCTOR)
    ) {
      defs[ListingColumnKey.REPORTED_DOCTOR] = {
        listingColumnKey: ListingColumnKey.REPORTED_DOCTOR,
        title: "Reported Doctor",
        dataIndex: "reports",
        width: 225,
        onCell: getCustomCellStyles(225),
        render: (_reports: Report[], caseDetail: CaseDetail) => {
          const reports = getReportedReports(caseDetail);
          if (!reports.length) return "-";
          const latestReport = reports.reduce((a, b) => {
            const aDate = a?.updatedAt ? new Date(a.updatedAt) : new Date(0);
            const bDate = b?.updatedAt ? new Date(b.updatedAt) : new Date(0);
            return aDate > bDate ? a : b;
          });
          return latestReport?.reportedDoctor || "-";
        },
      };
    }

    defs[ListingColumnKey.TIME_ELAPSED] = {
        listingColumnKey: ListingColumnKey.TIME_ELAPSED,
        title: "Time Elapsed",
        dataIndex: "timeElapsed",
        key: "timeElapsed",
        ellipsis: true,
        width: 120,
        onCell: getCustomCellStyles(120),
      };

    defs[ListingColumnKey.TAT] = {
        listingColumnKey: ListingColumnKey.TAT,
        title: "TAT",
        dataIndex: "tat",
        key: "tat",
        ellipsis: true,
        width: 100,
        onCell: getCustomCellStyles(100),
      };

    if (
      adminFeatures &&
      adminFeatures?.includes(AdminFeatureEnum.SHOW_REPORTED_TIME)
    ) {
      defs[ListingColumnKey.REPORTED_TIME] = {
              listingColumnKey: ListingColumnKey.REPORTED_TIME,
              title: "Reported Time",
              dataIndex: "reportedTime",
              key: "reportedTime",
              ellipsis: true,
              render: (date: string) => (
                <span>
                  {date ? (
                    <span>
                      {moment(date).format("DD-MMM-YY")}{" "}
                      {moment(date).format("hh:mm A")}
                    </span>
                  ) : (
                    "NA"
                  )}
                </span>
              ),
              width: 150,
              onCell: getCustomCellStyles(150),
            };
    }

    defs[ListingColumnKey.CASE_STATUS] = {
        listingColumnKey: ListingColumnKey.CASE_STATUS,
        title: "Case Status",
        dataIndex: "caseStatus",
        key: "caseStatus",
        width: 130,
        onCell: getCustomCellStyles(130),
        ellipsis: true,
        render: (status: string) => {
          const caseStatus =
            status === CaseStatusEnum.ASSIGNED ||
            status === CaseStatusEnum.TO_BE_APPROVED
              ? CaseStatusEnum.REPORT_PENDING
              : status;
          return (
            <span className={`scan-center-cases__status ${caseStatus}`}>
              {formatStatus(caseStatus)}
            </span>
          );
        },
      };

    defs[ListingColumnKey.UPLOAD_STATUS] = {
        listingColumnKey: ListingColumnKey.UPLOAD_STATUS,
        title: "Upload Status",
        dataIndex: "uploadStatus",
        key: "uploadStatus",
        width: 120,
        onCell: getCustomCellStyles(120),
        ellipsis: true,
        render: (status: string, caseDetail: CaseDetail) =>
          caseDetail?.id && (
            <span className="text-capitalize scan-center-cases__status-loader">
              {completedCaseIds?.includes(caseDetail?.id)
                ? "Complete"
                : uploadStartedCaseIds?.includes(caseDetail?.id)
                ? "Upload Started"
                : pendingCaseIds?.includes(caseDetail?.id)
                ? "Pending"
                : status.split("_").join(" ")}
              {caseDetail?.id &&
                (pendingCaseIds?.includes(caseDetail?.id) ||
                  uploadStartedCaseIds?.includes(caseDetail?.id)) && (
                  <AppLoader loading />
                )}
            </span>
          ),
      };

    defs[ListingColumnKey.ACTIONS] = {
        listingColumnKey: ListingColumnKey.ACTIONS,
        title: "Actions",
        dataIndex: "id",
        key: "id",
        width: SCAN_CENTER_DEFAULT_ACTIONS_COLUMN_WIDTH,
        render: (id: number, caseDetail: CaseDetail) => {
          const reportedReports = getReportedReports(caseDetail);
          const latestReport = reportedReports.length > 0
          ? reportedReports.reduce((a, b) => {
              const aDate = a?.updatedAt ? new Date(a.updatedAt) : new Date(0);
              const bDate = b?.updatedAt ? new Date(b.updatedAt) : new Date(0);
              return aDate > bDate ? a : b;
            })
          : undefined;
          const chatUnread = getDisplayedCaseChatUnread(
            caseDetail.id,
            caseDetail.unreadChatCount,
            caseChatUnreadCounts,
            caseChat?.id ?? null
          );
          return (
            <div
              onClick={(e) => e.stopPropagation()}
              className="case-list__row-actions"
            >
              {caseDetail?.caseStatus !== CaseStatusEnum.REPORTED && (
                <Tooltip title="Edit Case">
                  <Button
                    icon={<EditOutlined />}
                    onClick={handleEditCase(caseDetail)}
                  />
                </Tooltip>
              )}

              {hasAssignmentCapability &&
                caseDetail.uploadStatus === "complete" &&
                caseDetail.caseStatus !== CaseStatusEnum.REPORTED && (
                  <Tooltip title="Assign case">
                    <Popover
                      visible={assignPopoverOpenCaseId === caseDetail.id}
                      onVisibleChange={(visible: boolean) => {
                        if (visible) {
                          setAssignPopoverOpenCaseId(caseDetail.id ?? null);
                        } else if (assignPopoverOpenCaseId === caseDetail.id) {
                          setAssignPopoverOpenCaseId(null);
                        }
                      }}
                      destroyTooltipOnHide
                      overlayClassName="admin-cases__assignment-popover"
                      placement="bottomLeft"
                      content={
                        <div>
                          <CaseAssignmentForm
                            caseDetail={caseDetail}
                            onSuccess={handleAssignmentSuccess}
                          />
                        </div>
                      }
                      title="Assign case"
                      trigger="click"
                    >
                      <Button icon={<UserAddOutlined />} />
                    </Popover>
                  </Tooltip>
                )}

              {adminFeatures?.includes(AdminFeatureEnum.DIGITAL_SHARING) &&
                !adminFeatures?.includes(AdminFeatureEnum.WHATSAPP_SHARING) && (
                  <>
                    <Tooltip title="Copy Link">
                      <Button
                        icon={<CopyOutlined />}
                        className="clickable-icon"
                        onClick={() => {
                          Notification({
                            message: "Copied",
                            type: NotificationTypes.SUCCESS,
                          });
                          handleCaseShareLink(caseDetail);
                        }}
                      />
                    </Tooltip>
                    <Tooltip title="Copy QR">
                      <Button
                        icon={<QrcodeOutlined />}
                        className="clickable-icon"
                        onClick={() => {
                          handleCaseShareQr(caseDetail);
                        }}
                      />
                    </Tooltip>
                  </>
                )}

              {adminFeatures?.includes(AdminFeatureEnum.DIGITAL_SHARING) &&
                adminFeatures?.includes(AdminFeatureEnum.WHATSAPP_SHARING) && (
                  <Tooltip title="Share Link">
                    <Popover
                      destroyTooltipOnHide
                      // Reuse the admin cases popover class so spacing /
                      // alignment tweaks live in one place.
                      overlayClassName="admin-cases__share-popover"
                      placement="bottomLeft"
                      content={
                        <div>
                          <Menu mode="vertical" className="border-none">
                            <Menu.Item
                              className="navbar-item m-0"
                              key="copy_share_link"
                              onClick={() => {
                                Notification({
                                  message: "Copied",
                                  type: NotificationTypes.SUCCESS,
                                });
                                handleCaseShareLink(caseDetail);
                              }}
                            >
                              <CopyOutlined />
                              Copy Sharing Link
                            </Menu.Item>
                            <Menu.Item
                              className="navbar-item m-0"
                              key="copy_share_qr"
                              onClick={() => {
                                handleCaseShareQr(caseDetail);
                              }}
                            >
                              <QrcodeOutlined />
                              Copy QR
                            </Menu.Item>
                          </Menu>
                          <div>
                            {/*
                              Scan centers don't have access to the admin-only
                              referring-doctor endpoint, so we hide that row
                              and only expose the mobile-number WhatsApp flow.
                            */}
                            <CaseSharing
                              caseDetail={caseDetail}
                              showReferringDoctor={false}
                            />
                          </div>
                        </div>
                      }
                      title="Share Case Link"
                      trigger="click"
                    >
                      <Button
                        icon={<ShareAltOutlined />}
                        className="clickable-icon"
                      />
                    </Popover>
                  </Tooltip>
                )}
  
              {caseDetail?.caseStatus === CaseStatusEnum.REPORTED && (
                <Tooltip title="Download Latest Report">
                  <Popover
                    destroyTooltipOnHide
                    overlayClassName="admin-cases__assignment-popover"
                    placement="bottomLeft"
                    content={
                      <div>
                        <Menu mode="vertical" className="border-none">
                          {
                            latestReport?.directReportUpload ? (
                              <Menu.Item
                                className="navbar-item m-0"
                                key="download_direct_report"
                                onClick={() => {
                                  handleDownloadDirectReport(
                                      caseDetail,
                                      latestReport?.id
                                  );
                                }}>
                                  Download Report
                              </Menu.Item>
                            ) : (
                            <>
                              <Menu.Item
                                className="navbar-item m-0"
                                key="view"
                                onClick={() => {
                                  handleViewReport(
                                      caseDetail,
                                      latestReport?.id
                                  );
                                }}
                            >
                              View Report
                              </Menu.Item>
                              <Menu.Item
                                className="navbar-item m-0"
                                key="with_letterhead"
                                onClick={() => {
                                  handleDownloadCase(
                                    caseDetail,
                                    DownloadFileTypeEnum.PDF,
                                    true,
                                    latestReport?.id
                                  );
                                }}
                              >
                                Download with Letterhead
                              </Menu.Item>
                              <Menu.Item
                                className="navbar-item m-0"
                                key="without_letterhead"
                                onClick={() => {
                                  handleDownloadCase(
                                    caseDetail,
                                    DownloadFileTypeEnum.PDF,
                                    false,
                                    latestReport?.id
                                  );
                                }}
                              >
                                Download without Letterhead
                              </Menu.Item>
                              <Menu.Item
                                className="navbar-item m-0"
                                key="as_word"
                                onClick={() => {
                                  handleDownloadCase(
                                    caseDetail,
                                    DownloadFileTypeEnum.WORD,
                                    false,
                                    latestReport?.id
                                  );
                                }}
                              >
                                Download as Word
                              </Menu.Item>
                            </>
                            )
                          }
                        </Menu>
                      </div>
                    }
                    title="Download Latest Report"
                    trigger="click"
                  >
                    <Button
                      loading={
                        activeCase?.id === caseDetail?.id && downloadLoading
                      }
                      icon={<DownloadOutlined />}
                    />
                  </Popover>
                </Tooltip>
              )}
              <Tooltip title="Case chat">
                <Badge
                  count={chatUnread}
                  size="small"
                  offset={[-2, 2]}
                  overflowCount={99}
                >
                  <Button
                    icon={<CommentOutlined />}
                    onClick={() => {
                      setCaseChatDrawerCaseId(caseDetail.id!);
                      setCaseChat({
                        id: caseDetail.id!,
                        title:
                          caseDetail.patientName ||
                          caseDetail.patientId ||
                          `Case #${caseDetail.id}`,
                      });
                    }}
                  />
                </Badge>
              </Tooltip>
              {reportedReports.length > 0 && (
                <Tooltip title="Report History">
                  <Button
                    icon={<HistoryOutlined />}
                    onClick={() => {
                      setActiveCase(caseDetail);
                      setShowReportHistory(true);
                    }}
                  />
                </Tooltip>
              )}
            </div>
          )
        },
        onCell: () => ({ className: "scan-center-cases__actions-cell" }),
      };

    const fallbackOrder =
      listingPrefsApi?.eligible_column_keys?.filter((k) => defs[k])?.length
        ? listingPrefsApi!.eligible_column_keys.filter((k) => defs[k])
        : Object.keys(defs);

    setColumns(
      applyListingColumnPreferences(
        defs,
        listingPrefsApi?.columns ?? null,
        fallbackOrder,
        {
          actionsDefaultWidth: SCAN_CENTER_DEFAULT_ACTIONS_COLUMN_WIDTH,
          actionsMinWidth: SCAN_CENTER_ACTIONS_COLUMN_MIN_WIDTH,
        }
      )
    );
  }, [
    me,
    caseDetails,
    caseChat,
    caseChatUnreadCounts,
    downloadLoading,
    listingPrefsApi,
    pendingCaseIds,
    completedCaseIds,
    uploadStartedCaseIds,
    assignPopoverOpenCaseId,
  ]);

  const updatedColumns = columns.map((col: any, index: any) => ({
    ...col,
    title: (
      <div className="resizable-header">
        {col.title}
        <div
          className="resizer"
          onMouseDown={(e) => handleMouseDown(e, index)}
        />
      </div>
    ),
  }));

  return (
    <div className="scan-center-cases">
      <AppCard>
        <Row>
          <Col span={12}>
            <h2 className="mt-2">Cases</h2>
          </Col>
          <Col span={12} className="text-right">
            <Button type="primary" onClick={handleAddCase}>
              <PlusOutlined /> Add Case
            </Button>
          </Col>
        </Row>
        <CaseFilterForm
          isScanCenter
          formValues={formValues}
          onReset={handleResetFilters}
          onSync={handleFetchCases}
          loading={isSyncing}
          onListingColumnsSaved={() => {
            ListingColumnPreferenceService.fetch(
              UserRoleEnum.SCAN_CENTER,
              LISTING_CONTEXT.SCAN_CENTER_CASES,
              (data) => setListingPrefsApi(data),
              () => setListingPrefsApi(null),
              () => {}
            );
          }}
        />
        {
          loading ? <AppLoader loading={loading} /> : 
          (
            <Table
              dataSource={caseDetails}
              rowKey={(record) => record.id ?? 0}
              rowClassName={caseListRowClassName}
              onRow={handleRowChange}
              scroll={{ x: "max-content", y: `calc(100vh - 410px)` }}
              columns={updatedColumns}
              expandable={{
                expandedRowRender: (record) => (
                  <CaseSeriesExpandRow
                    caseDetailId={record.id!}
                    fetchThumbnails={ScanCenterCaseService.showCaseThumbnails}
                    fetchDicomFiles={AdminCaseService.showAdminCaseDirectoryFiles}
                    onSeriesOpen={handleSeriesOpen}
                  />
                ),
                rowExpandable: (record) => record.id != null,
              }}
              pagination={{
                current: paginationMeta?.currentPage,
                pageSize: paginationMeta?.perPage,
                total: paginationMeta?.totalCount,
                showSizeChanger: true,
                pageSizeOptions: ["10", "15", "20", "50"],
              }}
              onChange={handlePageChange}
            />
          )
        }
        {caseDetails.length > 0 && <TagLegend />}
        <Modal
          destroyOnClose
          visible={showCaseOverview}
          className="primary-modal"
          onCancel={handleCloseCaseOverview}
          footer={null}
          maskClosable={false}
        >
          {activeCase && (
            <CaseOverview
              activeCaseId={activeCase?.id}
              onCancel={handleCloseCaseOverview}
            />
          )}
        </Modal>

        <Modal
          destroyOnClose
          visible={showReportHistory}
          onCancel={handleToggleReportHistory}
          footer={null}
          maskClosable={false}
          className="primary-modal"
        >
          <ReportHistory caseDetail={activeCase} userRole={UserRoleEnum.SCAN_CENTER} />
        </Modal>

        <Modal
          destroyOnClose
          visible={showCaseForm}
          className="primary-modal"
          onCancel={handleToggleCaseForm}
          footer={null}
          maskClosable={false}
        >
          {activeCase && (
            <CaseForm
              caseDetailId={activeCase?.id}
              onSuccess={handleUploadCaseSuccess}
              onClose={() => setShowCaseForm(false)}
            />
          )}
        </Modal>
      </AppCard>
      <ContextMenu
        visible={menuVisible}
        position={menuPosition}
        selectedRow={selectedRow}
        onClose={() => setMenuVisible(false)}
        onUpdate={handleUpdateTags}
      />
      <CaseChatDrawer
        open={caseChat !== null}
        onClose={() => {
          setCaseChatDrawerCaseId(null);
          setCaseChat(null);
        }}
        caseDetailId={caseChat?.id ?? null}
        title={caseChat?.title}
        userRole={UserRoleEnum.SCAN_CENTER}
        currentUserId={me?.id}
      />
    </div>
  );
}

export default CaseContainer(ScanCenterCases);
